import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function Gustavo() {
  return (
    <AdvisorProvider advisor={advisors["gustavo"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}